import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { theme } from '../theme';
import { disponivel, escanear } from '../platform/scanner';

/**
 * Botao de camera ao lado de um campo de codigo de barras.
 *
 * Nao renderiza nada na web — o scanner e um atalho do app; digitar o codigo
 * continua sendo o caminho que funciona em qualquer lugar.
 *
 * @param {(codigo: string) => void} onLido
 */
export default function BotaoScanner({ onLido, titulo = 'Escanear código de barras' }) {
  const [lendo, setLendo] = useState(false);

  if (!disponivel()) return null;

  const abrir = async () => {
    if (lendo) return;
    setLendo(true);
    try {
      const r = await escanear({ tipo: 'produto' });
      if (r.ok) {
        onLido(r.valor);
        return;
      }
      if (r.motivo === 'sem-permissao') {
        toast.warn('Libere o acesso à câmera nas configurações do aparelho para escanear.');
      } else if (r.motivo === 'erro') {
        toast.error('Não consegui ler o código. Tente de novo ou digite.');
      }
      // 'cancelado' e silencioso: a usuaria fechou de proposito
    } finally {
      setLendo(false);
    }
  };

  return (
    <button
      type="button"
      onClick={abrir}
      disabled={lendo}
      title={titulo}
      aria-label={titulo}
      style={{
        flexShrink: 0,
        width: 44, height: 44,
        borderRadius: 10,
        border: `1px solid ${theme.colors.border}`,
        background: lendo ? theme.colors.bgSection : '#fff',
        cursor: lendo ? 'default' : 'pointer',
        fontSize: 20, lineHeight: 1,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      {lendo ? '…' : '📷'}
    </button>
  );
}
